export default __webpack_public_path__ + "static/media/icon-crypto.7fe11a8e.svg";